import { colorEstadoChip, icon } from "./coloresEstados";
import { insertColumnAfter } from '../../../helpers/tools';
import { CustomChip } from "../../../components/chip/Chip";

const columnUrgencia = {
    width: 80,
    field: 'cantidadUrgencias',
    headerName: 'Urgencia'
};

const columnSonda = {
    width: 80,
    field: 'cantidadCambioSonda',
    headerName: 'Sonda'
};

const columnCapacitacion = {
    width: 100,
    field: 'cantidadCapacitacion',
    headerName: 'Capacitación'
};

const columnPendienteAutorizar = {
    width: 120,
    field: 'visitasPendientesAutorizar',
    headerName: 'Pend. Autorizar',
    align: "center",
    renderCell: ({ row }) => {
        const color = !!row?.visitasPendientesAutorizar && row?.visitasPendientesAutorizar > 0 ? { isRed: true } : { isGreen: true };
        return (<CustomChip sx={{ borderRadius: '50%' }} label={row?.visitasPendientesAutorizar} {...color} />);
    }
};

const columnsBase = [
    {
        width: 80,
        field: 'idEvaluacion',
        headerName: '#'
    },
    {
        width: 80,
        field: 'idPaciente',
        headerName: 'HC'
    },
    {
        width: 200,
        field: 'paciente',
        headerName: 'Paciente'
    },
    {
        width: 20,
        field: 'pacienteNuevo',
        headerName: 'PN'
    },
    {
        width: 80,
        field: 'estadoContrato',
        headerName: 'Estado'
    },
    {
        width: 60,
        field: 'fase',
        headerName: 'Fase'
    },
    {
        width: 80,
        field: 'programa',
        headerName: 'Programa'
    },
    {
        width: 210,
        field: 'planCuidado',
        headerName: 'Plan'
    },
    {
        width: 140,
        field: 'profesional',
        headerName: 'Profesional'
    },
    {
        width: 110,
        field: 'figuraProfesional',
        headerName: 'Figura'
    },
    {
        width: 160,
        field: 'fechaAsignacion',
        headerName: 'F. de Asignación'
    },
    {
        width: 120,
        field: 'frecuencia',
        headerName: 'Frecuencia'
    },
    {
        width: 80,
        field: 'cumplio',
        headerName: 'Cumplió',
        align: "center",
        renderCell: ({ row }) => {
            const color = colorEstadoChip[row?.colorCumplimiento];
            return (<CustomChip icon={!!row?.cumplio ? icon['success'] : icon['error']} {...color} sx={{
                width: '1.8em',
                height: '1.8em',
                borderRadius: '50%',
                '& .MuiChip-icon': {
                    color: 'common.white',
                    fontSize: '1rem'
                }
            }} />);
        }
    },
    columnPendienteAutorizar,
    // {
    //     width: 100,
    //     field: 'visitasJustificadas',
    //     headerName: 'Visitas Just.'
    // },
    {
        width: 100,
        field: 'visitasProgramadas',
        headerName: 'Visitas Prog.',
        valueGetter: (_, row) => {
            return row.visitasRealizadas + '/' + row.visitasEstimadas + (row?.visitasJustificadas > 0 ? ` (+J:${row?.visitasJustificadas})` : '');
        }
    },
];

export const columnsMedicoNutriFono = insertColumnAfter(columnsBase, [columnUrgencia], 'visitasProgramadas');

export const columnsEnfermero = insertColumnAfter(columnsBase, [columnUrgencia, columnSonda, columnCapacitacion], 'visitasProgramadas');

export const columnsOtrosProfesionales = columnsBase;


